<template>
  <div>
    <div class="contents tournament">
      <b-form @submit="onSubmit">
        <div class="row row-cols-2 row-cols-lg-5 g-2 mb-4">
          <div class="col">
            <select
              aria-label="Select Mini Game Type"
              name="type"
              v-model="searchData.display_flag"
            >
              <option value="-1" disabled>
                {{ $t("title.common.display") }}
              </option>
              <option value="">{{ $t("filter.common.total") }}</option>
              <option value="0">Hide</option>
              <option value="1">Show</option>
            </select>
          </div>
          <div class="col">
            <select class="form-select-lg" v-model="searchData.status">
              <option value="0">{{ $t("filter.common.total") }}</option>
              <option value="1">{{ $t("filter.common.ready") }}</option>
              <option value="2">{{ $t("filter.common.playing") }}</option>
              <option value="3">{{ $t("filter.common.completed") }}</option>
              <option value="4">{{ $t("filter.common.cancel") }}</option>
            </select>
          </div>
          <div class="col-12 col-sm-12">
            <select
              aria-label="Select Rank Type"
              name="type"
              v-model="searchData.tour_rank_type"
            >
              <option value="-1">{{ $t("filter.common.total") }}</option>
              <option value="0">
                {{ $t("filter.tournament.low_gross") }} /
                {{ $t("filter.tournament.low_net") }}
              </option>
              <option value="1">{{ $t("filter.tournament.low_gross") }}</option>
              <option value="2">
                {{ $t("filter.tournament.low_net") }}
              </option>
            </select>
          </div>
          <div class="col-12 col-sm-6">
            <select class="form-select-lg" v-model="searchData.searchtype">
              <option value="1">{{ $t("filter.common.title") }}</option>
              <option value="2">
                {{ $t("filter.tournament.golfcourse_name") }}
              </option>
            </select>
          </div>
          <div class="col-12 col-sm-6">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchData.searchname"
              />

              <button
                class="btn btn-primary btn-lg icon-search"
                type="submit"
                value=""
              ></button>
            </div>
          </div>
        </div>
      </b-form>

      <table class="table board toggle-xl">
        <thead>
          <tr>
            <!-- <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th> -->
            <th class="col-auto">{{ $t("title.common.title") }}</th>
            <!--             <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.type") }}
            </th> -->
            <th class="col-auto d-none d-sm-table-cell text-center">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.course") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.entry_limit") }}
            </th>
            <!-- <th class="col-auto d-none d-lg-table-cell">Location</th> -->
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.registration") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.display") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <!-- <td class="col-auto d-none d-lg-table-cell">
                {{ item.no }}
              </td> -->
              <td class="col-auto text-start">
                <router-link
                  :to="{
                    name: 'TournamentView',
                    params: {
                      tournamentno: item.tournamentinfo.tournamentno,
                    },
                  }"
                  class="d-inline-block"
                >
                  <p class="badge-group">
                    <span class="badge tourn-type">
                      {{ tournament_type(item.tournamentinfo.type) }}
                    </span>
                    <span class="badge tourn-game-type">
                      {{ game_type(item.tournamentinfo.gametype_fk) }}
                    </span>
                  </p>
                  <p class="tourn-title more">
                    {{ item.tournamentinfo.title }}
                  </p>
                  <p class="tourn-rank-type">
                    {{ item.tournamentinfo.tour_rank_type | tour_rank_type }}
                  </p>
                </router-link>
              </td>

              <td class="col-auto d-none d-sm-table-cell text-center text-date">
                {{ item.tournamentinfo.timezone_startdate | dateformat }}
                ~
                {{ item.tournamentinfo.timezone_enddate | dateformat }}

              </td>
              <td class="col-auto d-none d-xl-table-cell">
                <p
                  v-for="(coures, index_c) in item.tournamentcourse"
                  :key="index_c + 'c'"
                >
                  {{ coures.coursename }}
                </p>
              </td>
              <td class="col-auto d-none d-xl-table-cell text-red">
                {{ item.tournamentinfo.entrylimit | transToValue("∞") }}
              </td>
              <!-- <td class="col-auto d-none d-lg-table-cell">
                <p
                  v-for="(shop, index_c) in item.tournamentshop"
                  :key="index_c + 's'"
                >
                  {{ shop.shopname }}
                </p>
              </td> -->
              <td class="col-auto d-none d-xl-table-cell text-date">
                {{ item.tournamentinfo.timezone_regdate | dateformat }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ change_status(item.tournamentinfo.status) }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ item.tournamentinfo.display_flag == "1" ? "Show" : "Hide" }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <!-- <button
                  type="button"
                  class="btn btn-outline-secondary btn-xs"
                  @click="oneModalOpen(item.tournamentinfo.tournamentno)"
                >
                  {{ $t("button.tournament.participant") }}
                </button> -->

                <button
                  type="button"
                  class="btn btn-primary btn-xs"
                  @click="
                    $router.push({
                      name: 'TournamentRank',
                      params: {
                        tournamentno: item.tournamentinfo.tournamentno,
                      },
                    })
                  "
                >
                  {{ $t("button.common.ranking") }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-xs"
                  @click="
                    $router.push({
                      name: 'TournamentModify',
                      params: {
                        tournamentno: item.tournamentinfo.tournamentno,
                      },
                    })
                  "
                >
                  {{ $t("button.common.edit") }}
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-xs text-white"
                  @click="
                    set_admintourdelete(
                      item.tournamentinfo.tournamentno,
                      item.deleteflag
                    )
                  "
                >
                  {{ $t("button.common.delete") }}
                </button>
                <button
                  type="button"
                  class="btn btn-success btn-xs text-white"
                  @click="reprocess(item.tournamentinfo.tournamentno)"
                >
                  {{ $t("button.common.reprocessing") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td class="text-start" colspan="8">
                <div class="toggle-content">
                  <!-- <div class="row">
                    <div class="col-5">{{ $t("title.common.number") }}</div>
                    <div class="col-7">{{ item.no }}</div>
                  </div> -->

                  <div class="row d-sm-none">
                    <div class="col-5">{{ $t("title.common.date") }}</div>
                    <div class="col-7 text-date">
                      {{ item.tournamentinfo.timezone_startdate | dateformat }}
                      ~
                      {{ item.tournamentinfo.timezone_enddate | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.common.course") }}
                    </div>
                    <div class="col-7">
                      <p
                        v-for="(coures, index_c) in item.tournamentcourse"
                        :key="index_c + 'c'"
                      >
                        {{ coures.coursename }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.common.entry_limit") }}
                    </div>
                    <div class="col-7 text-red">
                      {{ item.tournamentinfo.entrylimit | transToValue("∞") }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-5">Location</div>
                    <div class="col-7">
                      <p
                        v-for="(shop, index_c) in item.tournamentshop"
                        :key="index_c + 's'"
                      >
                        {{ shop.shopname }}
                      </p>
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col-5">
                      {{ $t("title.common.registration") }}
                    </div>
                    <div class="col-7 text-date">
                      {{ item.tournamentinfo.timezone_regdate | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.status") }}</div>
                    <div class="col-7">
                      {{ change_status(item.tournamentinfo.status) }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5">{{ $t("title.common.display") }}</div>
                    <div class="col-7">
                      {{
                        item.tournamentinfo.display_flag == "1"
                          ? "Show"
                          : "Hide"
                      }}
                    </div>
                  </div>
                  <div class="row d-lg-none">
                    <div class="col-5">{{ $t("title.common.control") }}</div>
                    <div class="col-7">
                      <!-- <button
                        type="button"
                        class="btn btn-outline-secondary btn-xs"
                        @click="oneModalOpen(item.tournamentinfo.tournamentno)"
                      >
                        {{ $t("button.tournament.participant") }}
                      </button> -->
                      <button
                        type="button"
                        class="btn btn-primary btn-xs"
                        @click="
                          $router.push({
                            name: 'TournamentRank',
                            params: {
                              tournamentno: item.tournamentinfo.tournamentno,
                            },
                          })
                        "
                      >
                        {{ $t("button.common.ranking") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary btn-xs"
                        @click="
                          $router.push({
                            name: 'TournamentModify',
                            params: {
                              tournamentno: item.tournamentinfo.tournamentno,
                            },
                          })
                        "
                      >
                        {{ $t("button.common.edit") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-xs text-white"
                        @click="
                          set_admintourdelete(
                            item.tournamentinfo.tournamentno,
                            item.deleteflag
                          )
                        "
                      >
                        {{ $t("button.common.delete") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-success btn-xs text-white"
                        @click="reprocess(item.tournamentinfo.tournamentno)"
                      >
                        {{ $t("button.common.reprocessing") }}
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="$router.push({ name: 'TournamentWrite' })"
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>

    <b-modal
      id="modal-participants"
      ref="modal-participants"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title" id="exampleModalLabel">Participants</h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-participants'].hide()"
        ></b-button>
      </template>

      <b-form @submit="onSubmit">
        <div class="filter-box-2">
          <div>
            <select
              class="form-select-lg"
              name="searchtype"
              v-model="modalsearchData.searchtype"
            >
              <option value="P.nickname">
                {{ $t("filter.common.nickname") }}
              </option>
              <option value="P.player_id">ID</option>
              <option value="O.nickname">
                {{ $t("filter.common.location") }}
              </option>
            </select>
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="searchname"
              v-model="modalsearchData.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>
      <table class="table board table-sm">
        <thead>
          <tr>
            <th class="d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="d-lg-table-cell">
              {{ $t("title.common.nickname") }}
              (ID)
            </th>
            <th class="d-none d-lg-table-cell">
              {{ $t("title.common.entry_ticket") }}
            </th>
            <th class="d-none d-lg-table-cell">
              {{ $t("title.common.used_ticket") }}
            </th>
            <th class="d-none d-lg-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <th class="d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="tournamentpaymentlistcnt > 0">
          <template v-for="(item, index) in tournamentpaymentlist">
            <tr :key="index">
              <td class="d-lg-table-cell">
                {{ item.no }}
              </td>
              <td
                class="d-lg-table-cell text-start more"
                @click="
                  allModalOpen({
                    player_pk: item.player_pk,
                    tour_pk: item.tour_pk,
                    owner_pk: item.owner_fk,
                  })
                "
              >
                {{ item.nickname }} ({{ item.player_id }})
              </td>
              <td class="d-none d-lg-table-cell">
                {{ item.entry_ticket_cnt | comma }}
              </td>
              <td class="d-none d-lg-table-cell text-date">
                {{ item.used_ticket_cnt | comma }}
              </td>
              <td class="d-none d-lg-table-cell text-date">
                {{ item.shopname }}
              </td>
              <td class="d-lg-table-cell text-date">
                {{ item.timezone_regdate | dateformat }}
              </td>

              <td class="td-arrow" @click="toggle_tr2(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide2 === index }"
                />
              </td>
            </tr>
            <tr
              class="d-lg-none"
              :class="{ show: view_hide2 === index }"
              :key="index + 'r'"
              v-if="view_hide2 === index"
            >
              <td colspan="4">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.entry_ticket") }}
                    </div>
                    <div class="col-8">{{ item.entry_ticket_cnt }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.used_ticket") }}
                    </div>
                    <div class="col-8">{{ item.used_ticket_cnt }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.location") }}</div>
                    <div class="col-8">{{ item.shopname }}</div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen2"
        :number-of-pages="tournamentpayment_page_total"
        v-model="modalsearchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="tournamentpayment_page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>

      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="cancel()"
          class="btn1"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-pay-history"
      ref="modal-pay-history"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title" id="exampleModalLabel">Pay History</h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-pay-history'].hide()"
        ></b-button>
      </template>

      <MemberInfo
        :nickname="playerpaymentinfo.nickname"
        :playerno="playerpaymentinfo.player_pk"
        :member_img="playerpaymentinfo.member_img"
        :badge_img="playerpaymentinfo.badge_img"
      />

      <div
        class="row row-cols-1 row-cols-sm-auto g-2 g-sm-3 mt-1 mt-sm-0 mb-3 fs-14"
      >
        <div class="col">
          <span class="fw-500 text-black">{{
            $t("title.common.entry_fee")
          }}</span>
          :
          <span class="text-price"
            >{{
              playerpaymentlist[0] &&
              playerpaymentlist[0].tor_amount &&
              playerpaymentlist[0].tor_amount
                | stripe_unit_amount(
                  playerpaymentlist[0] &&
                    playerpaymentlist[0].product_currency &&
                    playerpaymentlist[0].product_currency
                )
            }}
          </span>
        </div>

        <div class="col">
          <span class="fw-500 text-black">
            {{ $t("title.common.entry_ticket") }}</span
          >
          :
          {{ playerpaymentinfo.entry_ticket_cnt }}
        </div>
        <div class="col">
          <span class="fw-500 text-black">
            {{ $t("title.common.used_ticket") }}</span
          >
          :
          {{ playerpaymentinfo.used_ticket_cnt }}
        </div>
      </div>

      <table class="table board table-sm">
        <thead>
          <tr>
            <th class="d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="d-none d-lg-table-cell">
              {{ $t("title.admin.payment_no") }}
            </th>
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.title") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.admin.payment_date") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.admin.used_date") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="playerpaymentlist.length > 0">
          <template v-for="(item, index) in playerpaymentlist">
            <tr :key="index">
              <td class="d-lg-table-cell">
                {{ item.no }}
              </td>
              <td class="d-none d-lg-table-cell">
                {{ item.tor_key }}
              </td>
              <td class="d-lg-table-cell text-date">
                {{ item.title }}
              </td>
              <td class="d-none d-lg-table-cell text-date">
                {{ item.timezone_regdate | dateformat }}
              </td>
              <td class="d-none d-lg-table-cell text-date">
                <template v-if="item.tod_status == '1'">
                  {{ item.timezone_used_regdate | dateformat }}
                </template>
                <template v-else-if="item.tod_status == '2'">
                  {{ item.timezone_refund_regdate | dateformat }}
                  <br />(refund)
                </template>
                <template v-else>
                  <button
                    type="button"
                    class="btn btn-secondary btn-xs mx-auto"
                    @click="
                      refund({
                        player_pk: item.player_pk,
                        tour_pk: item.tour_pk,
                        tod_pk: item.tod_pk,
                        owner_pk: item.owner_fk,
                      })
                    "
                  >
                    {{ $t("button.admin.refund") }}
                  </button>
                </template>
              </td>

              <td class="td-arrow" @click="toggle_tr3(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide3 === index }"
                />
              </td>
            </tr>
            <tr
              class="d-lg-none"
              :class="{ show: view_hide3 === index }"
              :key="index + 'r'"
              v-if="view_hide3 === index"
            >
              <td colspan="4">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.admin.payment_no") }}
                    </div>
                    <div class="col-8">{{ item.tor_key }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.admin.payment_date") }}
                    </div>
                    <div class="col-8">
                      {{ item.timezone_regdate | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.admin.used_date") }}
                    </div>
                    <div class="col-8">
                      <template v-if="item.tod_status == '1'">
                        {{ item.timezone_used_regdate | dateformat }}
                      </template>
                      <template v-else-if="item.tod_status == '2'">
                        {{ item.timezone_refund_regdate | dateformat }}
                        <br />(refund)
                      </template>
                      <template v-else>
                        <button
                          type="button"
                          class="btn btn-secondary btn-xs mx-auto"
                          @click="
                            refund({
                              player_pk: item.player_pk,
                              tour_pk: item.tour_pk,
                              tod_pk: item.tod_pk,
                              owner_pk: item.owner_fk,
                            })
                          "
                        >
                          {{ $t("button.admin.refund") }}
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="cancel()"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/tournament";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "TournamentList",
  data() {
    return {
      searchData: {
        display_flag:
          this.$route.query.display_flag ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].display_flag) ||
          "",
        status:
          this.$route.query.status ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].status) ||
          0,

        tour_rank_type:
          this.$route.query.tour_rank_type ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].tour_rank_type) ||
          -1,
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },

      modalsearchData: {
        searchtype: "P.nickname",
        searchname: "",
        pageno: 1,
        tour_pk: 1,
      },

      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      tournamentpaymentlist: [],
      tournamentpaymentlistcnt: 0,
      tournamentpayment_page_total: 1,
      playerpaymentlist: [],
      playerpaymentinfo: {},
      view_hide: null,
      view_hide2: null,
      view_hide3: null,
    };
  },
  watch: {
    "searchData.display_flag": function () {
      this.searchData.pageno = 1;
      this.get_admintournamentlist();
    },
    "searchData.status": function () {
      this.searchData.pageno = 1;
      this.get_admintournamentlist();
    },
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.get_admintournamentlist();
    },
    "searchData.tour_rank_type": function () {
      this.searchData.pageno = 1;
      this.get_admintournamentlist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_admintournamentlist();
    },
    "searchData.pageno": function () {
      this.get_admintournamentlist();
    },

    "modalsearchData.searchtype": function () {
      this.modalsearchData.pageno = 1;
      this.get_tournamentpaymentlist();
    },
    "modalsearchData.searchname": function () {
      this.modalsearchData.pageno = 1;
      this.get_tournamentpaymentlist();
    },
    "modalsearchData.pageno": function () {
      this.get_tournamentpaymentlist();
    },
  },

  methods: {
    refund(param) {
      ax.post_paymentrefund(param, (flag, data) => {
        alert(data.message);
        if (flag) this.get_playerpaymentlist(param);
      });
    },
    allModalOpen(param) {
      this.get_playerpaymentlist(param);
    },

    oneModalOpen(tour_pk) {
      this.modalsearchData.tour_pk = tour_pk;
      this.get_tournamentpaymentlist();
    },
    get_playerpaymentlist(param) {
      ax.get_playerpaymentlist(param, (flag, data) => {
        if (flag) {
          this.playerpaymentlist = data.list;
          this.playerpaymentinfo = data.playerinfo;

          this.$refs["modal-pay-history"].show();
        } else {
          alert(data.message);
        }
      });
    },
    get_tournamentpaymentlist() {
      ax.get_tournamentpaymentlist(this.modalsearchData, (flag, data) => {
        if (flag) {
          this.tournamentpaymentlist = data.tournamentpaymentlist;
          this.tournamentpaymentlistcnt = data.tournamentpaymentlistcnt;
          this.tournamentpayment_page_total = Math.ceil(
            data.tournamentpaymentlistcnt / this.rows
          );

          this.$refs["modal-participants"].show();
        } else {
          alert(data.message);
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_admintournamentlist();
    },
    get_admintournamentlist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_admintournamentlist(this.searchData, (flag, data) => {
        if (flag) {
          if (data.tournamentlistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.tournamentlistcnt;
          this.page_total = Math.ceil(data.tournamentlistcnt / this.rows);
          this.items = data.tournamentlist;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          // if (data !== "no data") alert(data);
        }
      });
    },
    set_admintourdelete(tournamentno, deleteflag) {
      ax.set_admintourdelete(tournamentno, (flag, data) => {
        alert(data.message);
        if (flag) {
          this.get_admintournamentlist();
        }
      });
    },
    reprocess(tour_pk) {
      if (confirm(this.$i18n.t("text.common.reprocess_txt"))) {
        ax.set_reprocess(tour_pk, (flag, data) => {
          alert(data.message);

          if (flag) {
            if (data.code === 200) {
              this.get_admintournamentlist();
            }
            this.$bvModal.hide("modal-correction");
          } else {
            return false;
          }
        });
      }
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    linkGen2(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    toggle_tr2(index) {
      if (this.view_hide2 === index) this.view_hide2 = null;
      else this.view_hide2 = index;
    },
    toggle_tr3(index) {
      if (this.view_hide3 === index) this.view_hide3 = null;
      else this.view_hide3 = index;
    },
  },
  mounted() {
    this.get_admintournamentlist();
  },
  mixins: [myMixin],
};
</script>
